export default {
  animalsReleased:[],
  headquarters:[],
  animalsBirth:[],
  regimes:[],
  explanations:[],
  down_reasons:[],
  closure_reasons:[],
  birth_production_info:[],
  kill_list:[],
  degree_blood:[
    {name:"PC 31/32"},
    {name:"PC 63/64"},
    {name:"PC 127/128"},
    {name:"PC 255/256"},
    {name:"PC 511/512"},
    {name:"PC 1023/1024"},
    {name:"PC 2047/2048"},
    {name:"PC 4095/4096"},
    {name:"PC 8191/8192"},
    {name:"PC 16383/16384"},
    {name:"PC 32767/32768"},
    {name:"PC 65535/65536"},
    {name:"PC 131071/131072"},
    {name:"PC 262143/262144"},
    {name:"PC 524287/524288"},
    {name:"PC 1048575/1048576"},
    {name:"PC 2097151/2097154"},
    {name:"PC 4194303/4194304"},
    {name:"PC 8388607/8388608"},
    {name:"PC 16777215/16777216"},
    {name:"PC 33554431/33554432"},
    {name:"PC 67108863/67108864"},
    {name:"PO 1/1"},
    {name:"PA 31/32"},
    {name:"CCG 1/2"},
    {name:"CCG 1/4"},
    {name:"CCG 3/4"},
    {name:"CCG 1/8"},
    {name:"CCG 3/8"},
    {name:"CCG 5/8"},
    {name:"CCG 7/8"},
    {name:"CCG 3/16"},
    {name:"CCG 9/16"},
    {name:"CCG 11/16"},
    {name:"CCG 15/16"},
    {name:"PS 5/8"},
  ],
  child_conditions: [
    {id:0, name:"Bezerro vivo ao nascimento (parto normal)"},
    {id:1, name:"Bezerro morto ao nascimento (aborto)"},
    {id:2, name:"Bezerro morto após nascimento (natimorto)"},
    {id:3, name:"Parto sem auxílio"},
    {id:4, name:"Parto com tração fácil"},
    {id:5, name:"Parto com tração difícil"},
    {id:6, name:"Parto com cirurgia"},
    {id:7, name:"Parto com má apresentação do bezerro"},
    {id:8, name:"Parto não informado"},
    {id:9, name:"Prematuro"},
    {id:10, name:"Aborto"},
    {id:11, name:"Natimorto"},
    {id:12, name:"Lactação induzida"},
  ],
  kinds_birth:[
    {id:"SA", name:"Parto sem auxílio"},
    {id:"TF", name:"Parto com tração facil"},
    {id:"TD", name:"Parto com tração difícil"},
    {id:"CI", name:"Parto com cirurgia"},
    {id:"MA", name:"Parto com má apresentação do bezerro"},
    {id:"NI", name:"Parto não informado"},
    {id:"PR", name:"Prematuro"},
    {id:"AB", name:"Aborto"},
    {id:"NM", name:"Natimorto"},
    {id:"LI", name:"Lactação induzida"},
  ],
  races: [
    {title: "GIR"},
    {title: "GIROLANDO"},
    {title: "GIRSEY"},
    {title: "JERSEY"},
    {title: "JERSOLANDO"},
    {title: "HOLANDES"},
    {title: "PARDO SUÍÇO"},
    {title: "SINDI"},
    {title: "SINJER"},
    {title: "ANGUS"},
    {title: "WAGYU"},
    {title: "NORMANDO"},
    {title: "PIEMOENTÊS"},
    {title: "SUECO VERMELHO"},
    {title: "SRD SEMPRE COM GRAU DE SANGUE DESCONHECIDO"},
  ],
  birth_pagination:{},
  kills_pagination:{}
}